import Header from "./Header";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import useAuth from "../context/useAuth";

const UserLayout = () => {
  const { user } = useAuth();
  const role = Number(user?.role);
  const isSuperAdmin = role === 1;

  return (
    <div>
      <Header />
      {isSuperAdmin && <Sidebar />}
      <main className={`px-4 ${isSuperAdmin ? "admin-layout" : "user-layout"}`}>
        <Outlet />
      </main>
    </div>
  );
};

export default UserLayout;
